export function genUpTrend(oldPriceEp, priceEp, lastTrend) {
  if (priceEp > oldPriceEp) {
    return true;
  }
  if (priceEp < oldPriceEp) {
    return false;
  }
  return lastTrend;
}

export function genDownTrend(oldPriceEp, priceEp, lastTrend) {
  if (priceEp < oldPriceEp) {
    return true;
  }
  if (priceEp > oldPriceEp) {
    return false;
  }
  return lastTrend;
}

export function genUp(oldPriceEp, isInit, priceEp) {
  if (isNaN(oldPriceEp) || oldPriceEp === 0) {
    return false;
  }

  if (isInit || priceEp === 0) {
    return false;
  }

  return priceEp > oldPriceEp;
}

export function genDown(oldPriceEp, isInit, priceEp) {
  if (isNaN(oldPriceEp) || oldPriceEp === 0) {
    return false;
  }

  if (isInit || priceEp === 0) {
    return false;
  }

  return priceEp < oldPriceEp;
}
